import WorkflowStep from "./workflowStep";
import {WorkflowType} from "~/enums/forms/workflowSteps/workflowType";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import Validatable from "../../../../common/mixins/validatable";
import MappingStepValidation from "../../../../common/models/navigableValidations/mappingStepValidation";

export default class MappingStep extends Validatable(WorkflowStep) implements WorkflowStepInterface {
  mapping_id: string;
  mapping: {title: string, id: string, is_published: boolean};
  except = ['mapping'];

  constructor(form?) {
    super(form);
    this.defineProperty('workflow_type', WorkflowType.mapping);
    this.defineProperty('mapping_id', null);
  }

  get UNTRACKED_PROPERTIES(): string[] {
    return [
      'mapping',
    ];
  }
  //***** validation ***** //
  _validation: MappingStepValidation = new MappingStepValidation(this);

  get titleOrDefault(): string {
    if (this.hasTitle) {
      return this.title;
    } else {
      return `Mapping Triggered`;
    }
  }

  afterAppend(): void {
    super.afterAppend();
    // this.setSubmitterToOriginalSubmitter();
  }

}
